import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/css';
import { colors } from '@cimpress/react-components';

const Block = ({ style = {} }) => (
  <div
    className={css`
      min-height: 50px;
      min-width: 50px;
      background-color: ${colors.ocean.base};
    `}
    style={style}
  />
);

Block.propTypes = {
  shouldGrow: PropTypes.bool,
};

export default Block;
